<template>
  <div class="edit-osmp-deliverable-modal no-focus-visible-outline"
    :class="(deliverableDetail.permissions.viewOnly) ? 'read-only' : ''" v-show="deliverableDetail" tabindex="-1"
    ref="rootTag">
    <div class="departments__wrapper">
      <DeliverableDropdown :deliverable="deliverableDetail" :deliverableTypes="deliverableTypes"
        :classNames="'department-title'" :namespace="namespace" />
      <DeliverableDepartments v-if="showDepartment()" :deliverable="deliverableDetail"
        :namespace="namespace" />
      <DeliverableProjects :deliverable="deliverableDetail" :namespace="namespace" />
    </div>
    <label v-if="isMobile()" class="form-group w-100 sticky__delv__title">
      <h1 @click="activateTitleField" class="exclude-outside-click edit-d-title deliverable-title" v-show="!editTitle">{{
        deliverableDetail.title || 'Click to set...' }}</h1>
      <textarea v-click-outside="outside" ref="deliverableTitle" v-show="editTitle" v-model="deliverableDetail.title"
        type="text" :placeholder="getDeliverableTitlePlaceholder"
        class="form-control mb-3 title-field exclude-outside-click h1" @change="updateDeliverableTitle"
        @blur="editTitle = false;"></textarea>
    </label>

    <section class="plan-settings">
      <div class="settings-header">

        <b-button v-b-toggle.collapse-social-plan-dialog class="plan-group-toggle">
          <i class="fas fa-chevron-right collapse-indicator"></i>
        </b-button>
        <SocialMediaPlanTitle :deliverableDetail="deliverableDetail" :showSocialPlanDetails="!showSocialPlanDetails"
          :deliverableTypes="deliverableTypes" :namespace="namespace" />
        <div class="pb-0" v-show="!showSocialPlanDetails" @click="showSocialPlanDetails = !showSocialPlanDetails">
          <div class="group-title">
            <h1 class="mb-0 exclude-outside-click project-title" v-show="!editTitle">{{ deliverableDetail.title }}</h1>
          </div>
        </div>
      </div>
      <b-collapse v-model="showSocialPlanDetails" id="collapse-social-plan-dialog" class="settings-content-collapse">
        <div class="settings-content">
          <SocialMediaPlanDialog 
          :isEdit="showSocialPlanDetails" 
          :hideTitle="true" 
          :deliverableDetail="deliverableDetail" 
          :namespace="namespace" 
          />
        </div>
      </b-collapse>
    </section>
    <b-tabs v-model="activeDeliverableTab" card>
      <b-tab title="Tasks" class="b-tab-tasks" @click="onTabClick">
        <div class="row">
          <div class="col-md-12">
            <div class="add-task-button-mobile">
              <b-button v-if="!(!userAbilities.editMediaCall || deliverableDetail.permissions.viewOnly)" variant="theme"
                class="add-task-btn" @click.stop="createTask">
                Add Task
                <div role="status" v-show="addingTask" class="ml-2 spinner-border spinner-border-sm text-primary"><span
                    class="sr-only">Loading...</span></div>
              </b-button>
            </div>
            <TaskFieldLabels ref="TaskFieldLabelsRef" :fullDeliverables="deliverableDetail"
              :deliverableId="deliverableDetail.deliverableId" :deliverable="deliverableDetail"
              :tasks="deliverableDetail.tasks" :namespace="namespace" />
            <TaskFields :fullDeliverables="deliverableDetail" :deliverableId="deliverableDetail.deliverableId"
              :deliverable="deliverableDetail" :tasks="deliverableDetail.tasks" :namespace="namespace" />
          </div>
        </div>
      </b-tab>
      <b-tab title="Content Calendar" class="b-tab-content-calendar" @click="onTabClick">
        <RelatedDeliverablesGrouped v-if="deliverableDetail.deliverableId"
          :parentDeliverableId="deliverableDetail.deliverableId" :namespace="namespaceRelated"
          :tabTitle="'content-calendar'" :key="'eosmp-rdg'" :pageCount="getPageCount"
          ref="refRelatedDeliverablesGrouped" />
      </b-tab>
      <b-tab title="Scheduled Content" :lazy="lazyLoadCalendar" class="b-tab-scheduled-content" @click="onTabClick">
        <RelatedDeliverablesSchedule v-if="deliverableDetail.deliverableId"
          :parentDeliverableId="deliverableDetail.deliverableId" :namespace="namespaceRelated"
          :tabTitle="'scheduled-content'" :key="'eosmp-rds'" ref="refRelatedDeliverablesSchedule" />
      </b-tab>
    </b-tabs>

    <div :class="showModalOptions ? 'open' : ''" class="responsive-edit-modal-controls">
      <button v-b-tooltip.hover title="More options" @click="showModalOptions = !showModalOptions"
        class="btn modal-more-controls">
        <i class="fas" :class="!showModalOptions ? 'fa-arrow-left' : 'fa-arrow-right'"></i>
      </button>

      <button v-b-tooltip.hover :title="getDeleteDeliverableTitle"
        @click="removeDeliverable(deliverableDetail.deliverableId)" class="btn delete-deliverable-btn"
        v-if="userAbilities.deleteMediaCall && !deliverableDetail.permissions.viewOnly">
        <i class="fas fa-trash-alt"></i>
      </button>

      <DuplicateMediaCallBtn :deliverableId='deliverableDetail.deliverableId' :namespace="namespace"
        :deliverableTemplateId="deliverableDetail.deliverable_template_id" />
      <FeedbackBtn />
      <button v-b-tooltip.hover title="Close" @click="onCloseModal" class="btn close-deliverable-btn">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <b-modal v-model="showRemoveDeliverable" type="warn" title="Confirm Deletion" @ok="onConfirmRemoveDeliverable"
      ok-title="Yes, Delete">
      <p>Are you sure you want to delete this deliverable?</p>
    </b-modal>
    <b-modal size="lg" no-close-on-backdrop hide-footer id="editRelatedSocialModal"
      title="Edit Related Social Deliverable" class="modal-edit-social-deliverable" @show="editSocialModalShown"
      @shown="afterEditSocialModalShown"  @hide="editSocialModalHidden" @hidden="removeRoute" no-close-on-esc>
      <EditSocialModal :allContacts="allContacts" :tabIndex="socialModalTabIndex" ref="refEditRelatedSocialModal"
        @modalDetailUpdated="pushRoute" :namespace="namespaceRelated" />
    </b-modal>

  </div>
</template>

<script>
import Autocomplete from '@trevoreyre/autocomplete-vue';
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import toast from "../../toast";
import Format from "../../utility/Format";
import DuplicateMediaCallBtn from "../common/DuplicateMediaCallBtn";
import FeedbackBtn from "../common/FeedbackBtn";
import FullContactField from "../common/FullContactField";
import DeliverableDepartments from "./DeliverableDepartments";
import DeliverableDropdown from "./DeliverableDropdown";
import DeliverableProjects from "./DeliverableProjects";
import UpdateContactModal from "./EditContactModal";
import EditSocialModal from "./EditSocialModal";
import RelatedDeliverables from "./RelatedDeliverablesSocialMedia";
import RelatedDeliverablesGrouped from "./RelatedDeliverablesSocialMediaGrouped";
import RelatedDeliverablesSchedule from "./RelatedDeliverablesSocialMediaSchedule";
import SocialMediaPlanDialog from "./SocialMediaPlanDialog";
import SocialMediaPlanTitle from "./SocialMediaPlanTitle";
import TaskFieldLabels from "./TaskFieldLabels";
import TaskFields from "./TaskFields";



export default {
  data() {
    return {
      lazyLoadCalendar: true,
      tabClicked: false,
      tabSlug: "social-media",
      tabIndex: 0,
      socialModalTabIndex:0,
      enableEscape: true,
      namespaceRelated: "relatedDeliverables/",
      namespaceCalendar: "relatedDeliverablesCalendar/",
      Format,
      showModalOptions: false,
      renderCount: 1,
      newContactId: "",
      newContactName: "",
      editTitle: false,
      addingTask: true,
      addContactFlag: false,
      addWhoFlag: false,
      addSpokespersonFlag: false,
      showRemoveDeliverable: false,
      showRemoveContact: false,
      showRemoveSpokesperson: false,
      showRemoveWho: false,
      showRemoveResource: false,
      addResourceFlag: false,
      showSocialPlanDetails: false,
      contacts: [],
      linkCopyLinkTimeouts: {},
      activeDeliverableTab: null,
      planId: 0,
    };
  },
  components: {
    EditSocialModal,
    DeliverableProjects,
    DeliverableDropdown,
    RelatedDeliverables,
    RelatedDeliverablesGrouped,
    RelatedDeliverablesSchedule,
    SocialMediaPlanTitle,
    SocialMediaPlanDialog,
    TaskFields,
    TaskFieldLabels,
    UpdateContactModal,
    DeliverableDepartments,
    FullContactField,
    Autocomplete,
    FeedbackBtn,
    DuplicateMediaCallBtn,
  },
  props: ["allContacts", "modalId", "namespace"],
  computed: {
    ...mapGetters([
      "userAbilities",
      "getDeliverableTemplateSlug",
    ]),
    ...mapState({
      state(state) {
        return state[this.namespace]
      },
      getActiveTabIndex(state, getters) {
        return getters[this.namespace + 'getActiveTabIndex']
      },
      allDepartments(state, getters) {
        return getters[this.namespace + 'allDepartments']
      },
      allSubjects(state, getters) {
        return getters[this.namespace + 'allSubjects']
      },
      deliverableDetail(state, getters) {
        return getters[this.namespace + 'deliverableDetail']
      },
      allTags(state, getters) {
        return getters[this.namespace + 'allTags']
      },
      allRegions(state, getters) {
        return getters['allRegions']
      },
      deliverableContactsLabel(state, getters) {
        return getters['deliverableContactsLabel']
      },
      allCustomFields(state, getters) {
        return getters['allCustomFields']
      },
      initialContacts(state, getters) {
        return getters[this.namespace + 'initialContacts']
      },
      deliverableTypes(state, getters) {
        return getters['deliverableTypes']
      },
      socialMediaFilter(state, getters) {
        return getters[this.namespace + 'socialMediaFilter']
      },

    }),
    // so that we can use lodash in the template
    _() {
      return _;
    },
    getPageCount() {
      if (this.isListAllView) {
        return 2;
      } else {
        return 999999;
      }
    },


    getDeleteDeliverableTitle() {
      if (this.deliverableDetail) {

        const deliverableTypeObj = this.deliverableTypes.find(x => x.typeId == this.deliverableDetail.deliverable_template_id);
        const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(this.deliverableDetail.deliverable_template_id));
	    	if (deliverableTemplateSlug == "media-call") {
          return "Delete Media Call";
        } else {
          if (deliverableTypeObj) {
            return "Delete " + deliverableTypeObj.name;
          } else {
            return "Delete Deliverable";
          }
        }
      }
    },


    apiUrl() {
      return process.env.MIX_API_BASE_URL;
    },
    relatedTags() {
      let trendingTags = this.$store.state.deliverables.trendingTags,
        relatedTags = [];
      if (typeof this.deliverableDetail.tags != "undefined") {
        this.deliverableDetail.tags.forEach(deliverableTag => {
          trendingTags = _.reject(trendingTags, function (e) {
            return e.id == deliverableTag.id;
          });
        });
      }
      return trendingTags;
    },

    optionsForLinkType() {
      let linkTypeField = this.allCustomFields.find(x => x.id == 37);
      if (!linkTypeField) {
        this.$store.dispatch(this.namespace + "fetchAllCustomFields");
      } else {
        return JSON.parse(linkTypeField.value_set);
      }
    },
  },
  methods: {
    ...mapActions({
      updateFieldValue(dispatch, payload) {
        return dispatch(this.namespace + 'updateFieldValue', payload)
      },
      removeDeliverableContact(dispatch, payload) {
        return dispatch(this.namespace + 'removeDeliverableContact', payload)
      },
      removeDeliverableWho(dispatch, payload) {
        return dispatch(this.namespace + 'removeDeliverableWho', payload)
      },
      removeDeliverableSpokesperson(dispatch, payload) {
        return dispatch(this.namespace + 'removeDeliverableSpokesperson', payload)
      },
    }),
    ...mapMutations({
      setDeliverable(commit, payload) {
        return commit(this.namespace + 'setDeliverable', payload)
      },
      setActiveTabIndex(commit, payload) {
        return commit(this.namespace + 'setActiveTabIndex', payload); // Share tab indexes across all namespaces
      },
    }),
    updateDeliverableTitle() {
      this.deliverableDetail.title = Format.replaceLineBreaks(this.deliverableDetail.title, " ");
      this.updateFieldValue(this.deliverableDetail);
    },

    hasContactFields() {
      let contactCustomFields = _.filter(this.deliverableDetail.templateCustomFields, {field_type: 'contacts'});
      if (Array.isArray(contactCustomFields) && contactCustomFields.length) {
        // array exist, is not empty
        return true;
      }
    },

    getParentId(obj) {
      if (obj) {
        if (obj.parent_id) {
          return obj.parent_id;
        }
      }
      return null;
    },
    outside() {
      this.editTitle = false;
      this.addContactFlag = false;
      this.addSpokespersonFlag = false;
      this.addWhoFlag = false;
    },
    showAddContact() {
      this.addContactFlag = true;
      this.$nextTick(() => {
        this.$refs.deliverableContacts.$el.focus();
      });
    },
    showAddResource() {
      this.addResourceFlag = true;
    },

    showAddWho() {
      if (!this.userAbilities.editMediaCall || this.deliverableDetail.permissions.viewOnly) return;
      this.clearFlags();
      this.addWhoFlag = true;
      this.$nextTick(() => {
        this.$refs.searchWho.$refs.input.focus();
      });
    },
    clearFlags() {
      this.addSpokespersonFlag = false;
      this.addWhoFlag = false;
    },
    showAddSpokesperson() {
      if (!this.userAbilities.editMediaCall || this.deliverableDetail.permissions.viewOnly) return;
      this.clearFlags();
      this.addSpokespersonFlag = true;
      this.$nextTick(() => {
        this.$refs.searchSpokesperson.$refs.input.focus();
      });
    },
    onContactSearch(input) {
      this.isLoading = true;
      this.contacts = [];
      if (input.length < 1) {
        this.isLoading = false;
      } else {
        axios.get(process.env.MIX_API_BASE_URL + "contacts?q=" + encodeURI(input))
          .then(resp => {
            this.contacts = [];
            for (var contact of resp.data) {
              contact.name = contact.first_name + " " + contact.last_name;
              contact.commaName = contact.last_name + ", " + contact.first_name;
              this.contacts.push(contact);
            }
            this.isLoading = false;
          })
      }
    },
    contactCustomLabel({ name, company_name }) {
      if (company_name != null) {
        return `${name} – ${company_name}`
      } else {
        return `${name}`
      }
    },

    onSpokespersonSearch(input) {
      return new Promise((resolve, reject) => {
        input = input == false ? '' : input
        axios.get(process.env.MIX_API_BASE_URL + "activeContacts?q=" + encodeURI(input))
          .then(resp => {
            let contacts = [];
            let x = 0;
            contacts.push({ id: null, label: "Create new contact <strong>" + input + "</strong>", search: input, deliverablId: this.deliverableDetail.deliverableId });
            for (x = 0; x < resp.data.length; x++) {
              contacts.push(resp.data[x]);
            }
            this.$store.commit(this.namespace + 'setInitialData', { contacts: contacts })
            resolve(contacts);
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    onSpokespersonSelect(selected) {
      if (selected.id == null) {
        // add new contact..
        this.newContactId = null;
        this.createSpokesperson(selected.search, this.deliverableDetail.deliverableId);
      } else {
        this.newContactId = selected;
        this.inputAddContact('spokesperson');
      }
      this.$refs.searchSpokesperson.value = null;
      this.addSpokespersonFlag = false;
    },



    onWhoSearch(input) {
      return new Promise((resolve, reject) => {
        input = input == false ? '' : input
        axios.get(process.env.MIX_API_BASE_URL + "activeContacts?q=" + encodeURI(input))
          .then(resp => {
            let contacts = [];
            let x = 0;
            contacts.push({ id: null, label: "Create new contact <strong>" + input + "</strong>", search: input, deliverablId: this.deliverableDetail.deliverableId });
            for (x = 0; x < resp.data.length; x++) {
              contacts.push(resp.data[x]);
            }
            this.$store.commit(this.namespace + 'setInitialData', { contacts: contacts })
            resolve(contacts);
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    onWhoSelect(selected) {
      if (selected.id == null) {
        // add new contact..
        this.newContactId = null;
        this.createWho(selected.search, this.deliverableDetail.deliverableId);
      } else {
        this.newContactId = selected;
        this.inputAddContact('who');
      }
      this.$refs.searchWho.value = null;
      this.addWhoFlag = false;
    },

    onTabClick(evt) {
      // content calender
      let tab = evt.target.getAttribute("aria-posinset");
      if (tab == "1") {
      	this.socialModalTabIndex = 0;
      }
      if (tab == "2") {
      	this.socialModalTabIndex = 0;
        this.$refs.refRelatedDeliverablesGrouped.$refs.refHeaderControls.applyFilter();
      }
      if (tab == "3") {
        // scheduled content
        this.lazyLoadCalendar = false;
        this.socialModalTabIndex = 2;
        if (this.$refs.refRelatedDeliverablesSchedule) {
          // force resize of schedule
          this.$refs.refRelatedDeliverablesSchedule.$refs.refHeaderControls.applyFilter();
          this.$refs.refRelatedDeliverablesSchedule.$refs.refSocialScheduleCalendar.forceResizeCalender();
        }
      }
    },

    customChildField(key, parent_id) {


      if (this.deliverableDetail.customFields) {
        let obj = _.filter(this.deliverableDetail.customFields, { field_key: key, parent_id: parent_id });
        if (obj.length > 0) {
          // lets add it to the
          return obj;
        } else {
          let field = _.filter(this.allCustomFields, { field_key: key });
          // this breaks, its always undefined because customFields is an indexed array?
          if (typeof this.deliverableDetail.customFields[key] == "undefined") {
            return null;
          } else {
            obj = {};
            obj.id = null;
            obj.parent_id = this.deliverableDetail.customFields[key].id;
            obj.deliverable_id = this.deliverableDetail.customFields[key].deliverable_id;
            obj.editing = false;
            obj.field_id = field[0].id;
            obj.field_key = field[0].field_key;
            obj.field_parent_id = field[0].parent_id;
            obj.field_type = field[0].field_type;
            obj.note = field[0].note;
            obj.value = null;
            obj.label = field[0].label;
            obj.value_set = field[0].value_set;
            obj.updated_at = this.deliverableDetail.customFields[key].updated_at;
          }
          return [obj];
        }
      }
      return [];
    },


    customChildFieldValue(key, parent_id) {
      if (this.deliverableDetail.customFields) {
        let obj = _.filter(this.deliverableDetail.customFields, { field_key: key, parent_id: parent_id });
        if (obj != null) {
          if (obj.length > 0) {
            return obj[0].value;
          } else {
            return null;
          }
        }
      }
      return null;
    },



    createContact(newContactName) {
      this.$store.state.newContactName = newContactName;
      this.$store.state.deliverableId = deliverableId;
      this.$store.state.currentFieldKey = 'who';
      this.$bvModal.show("createContactModal");
    },
    createSpokesperson(newContactName, deliverableId) {
      this.$store.state.newContactName = newContactName;
      this.$store.state.deliverableId = deliverableId;
      this.$store.state.currentFieldKey = 'spokesperson';
      this.$bvModal.show("createSpokespersonModal");
    },
    createWho(newContactName, deliverableId) {
      this.$store.state.newContactName = newContactName;
      this.$store.state.deliverableId = deliverableId;
      this.$store.state.currentFieldKey = 'who';
      this.$bvModal.show("createWhoModal");
    },

    updateContact(contactData, fieldKey) {
      this.$store.state.currentContactData = contactData;
      this.$store.state.currentContactId = contactData.id;
      this.$store.state.currentFieldKey = fieldKey;
      if (fieldKey == 'who') {
        this.$bvModal.show("editWhoModal");
      }
      if (fieldKey == 'spokesperson') {
        this.$bvModal.show("editSpokespersonModal");
      }
    },

    contactsNotAdded(field_key) {
      let addedContacts = _.filter(this.deliverableDetail.customFields, {
        field_key: field_key
      }),
        allContacts = this.allContacts,
        addedIds = [];

      _.forEach(addedContacts, function (n, key) {
        addedIds.push(parseInt(n.value));
      });
      let result = _.reject(allContacts, function (o) {
        return addedIds.indexOf(o.id) != -1;
      });

      return result;
    },
    inputAddContact(field_key) {
      let x = 0;
      let field_id = null;
      for (x = 0; x < this.deliverableDetail.customFields.length; x++) {
        if (this.deliverableDetail.customFields[x].field_key == field_key) {
          field_id = this.deliverableDetail.customFields[x].field_id;
          break;
        }
      }
      this.newContactId.fieldId = field_id;
      switch (field_key) {
        case "who":
          this.addDeliverableWho({ contactData: this.newContactId, deliverableId: this.deliverableDetail.deliverableId });
          break;
        case "spokesperson":
          this.addDeliverableSpokesperson({ contactData: this.newContactId, deliverableId: this.deliverableDetail.deliverableId });
          break;
        default:
      }
    },
    addDeliverableSpokesperson(payload) {
      this.$store.dispatch(this.namespace + "addDeliverableSpokesperson", payload);
      this.newContactId = "";
    },
    addDeliverableWho(payload) {
      this.$store.dispatch(this.namespace + "addDeliverableWho", payload);
      this.newContactId = "";
    },

    addDeliverableContact(payload) {
      this.$store.dispatch(this.namespace + "addDeliverableContact", payload);
      this.newContactId = "";
    },
    removeDeliverable(deliverableId) {
      this.showRemoveDeliverable = true;
    },
    onConfirmRemoveDeliverable() {
      if (this.deliverableDetail.deliverableId) {
        let that = this;
        this.$store.dispatch(this.namespace + "removeDeliverable", { deliverableId: this.deliverableDetail.deliverableId }).then(function (response) {
          if (response && response?.status && response?.status != 200) {
            return;
          }
          that.$bvModal.hide("editOrganicSocialMediaPlanModal")

          that.$store.dispatch(that.namespace + 'fetchDeliverables').then(function () {
            toast.hide();

              that.$store.dispatch(that.namespace + 'manageUndoActivation', 'Deliverable deleted.');

            that.$store.dispatch(that.namespace + 'fetchProjectDeliverable');
          });
        });
      }
    },
    showRemoveDeliverableContact(contactId) {
      this.contactId = contactId;
      this.showRemoveContact = true;
    },
    onConfirmRemoveContact() {
      if (this.contactId) {
        this.removeDeliverableContact(this.contactId);
      }
    },

    onShowRemoveSpokesperson(contactId) {
      this.contactId = contactId;
      this.showRemoveSpokesperson = true;
    },
    onConfirmRemoveSpokesperson() {
      if (this.contactId) {
        this.removeDeliverableSpokesperson(this.contactId);
      }
    },

    onShowRemoveWho(contactId) {
      this.contactId = contactId;
      this.showRemoveWho = true;
    },
    onConfirmRemoveWho() {
      if (this.contactId) {
        this.removeDeliverableWho(this.contactId);
      }
    },

    onCloseModal() {
      let mId;
      if (this.modalId != undefined) {
        mId = this.modalId;
      } else {
        mId = "editOrganicSocialMediaPlanModal";
      }
      this.$bvModal.hide(mId);

      if (
        this.$router.currentRoute.name == 'calendar' ||
        this.$router.currentRoute.name == "projectDeliverable"
      ) {
        this.$root.$emit('re__fetch__calendar__data', this.deliverableDetail);
      }
      document.body.classList.remove("related-social-media");
    },


    setTag(newTag) {
      if (!this.userAbilities.editMediaCall || this.deliverableDetail.permissions.viewOnly) return;
      this.deliverableDetail.tags.push(newTag);
      this.$store.dispatch(this.namespace + "updateFieldValue", this.deliverableDetail);
    },

    activateTitleField() {
      if (!this.userAbilities.editMediaCall || this.deliverableDetail.permissions.viewOnly) return;
      let that = this
      this.editTitle = true;
      setTimeout(function () {
        that.$refs.deliverableTitle.select();
      }, 100)
    },


    showDepartment() {
    	return true;
    },


    setCookieForDownload() {
      this.$store.dispatch("setUserAuthCookie");
    },

    getLinkTypeObject(id) {
      if (id == null) id = 1;
      const r = this.optionsForLinkType.find(x => x.id == id);
      return r;
    },

    createTask() {
      this.$refs.TaskFieldLabelsRef.createTask();
    },


    onBVModalEnablePointerEvents(eventObj, params) {
      $('#editOrganicSocialMediaPlanModal .modal-content').removeClass('disable-pointer-events');

      this.enableEscape = true;
    },

    onBVModalDisablePointerEvents(eventObj, params) {
      const bodyElement = document.body;
      const modalOpenCount = bodyElement.getAttribute('data-modal-open-count');
      if (modalOpenCount > 0) {
        this.enableEscape = false;
        $('#editOrganicSocialMediaPlanModal .modal-content').addClass('disable-pointer-events');
        $('#editOrganicSocialMediaPlanModal .modal-content .related-deliverable-block-wrap .dtable').addClass('allow-pointer-events');
        $('#editOrganicSocialMediaPlanModal .modal-content .calendar-container').addClass('allow-pointer-events');
      }
    },

    escapeListener(e) {
      if (e.key == 'Escape') {
        if (this.enableEscape) {
          // this.onCloseModal();
        }
      }
    },
    editSocialModalShown() {
      document.body.classList.add("social-modal-open");
      $("#content").scrollTop(this.windowScrollTop);
    },
    afterEditSocialModalShown() {
      document.body.classList.add("social-modal-shown");
    },
    editSocialModalHidden() {
      this.windowScrollTop = $("#content").scrollTop();
      document.body.classList.remove("social-modal-open");
      document.body.classList.remove("social-modal-shown");
      $(window).scrollTop(this.windowScrollTop);
      this.$store.commit(this.namespace + 'setDeliverable', this.deliverableDetail);
      this.$store.commit(this.namespace + 'setCalendarDeliverable', this.deliverableDetail);
      this.selectedDeliverable = false;
      this.onBVModalEnablePointerEvents();
    },
    pushRoute() {
      return;
    },
    removeRoute() {
      history.pushState(
        {},
        null,
        this.$router.currentRoute.matched[0].path
      );
    },

  },
  mounted() {

    // Listen for ESC key to close the modal
    window.addEventListener('keydown', this.escapeListener);

    this.$root.$on('bv::modal::enable-pointer-events', this.onBVModalEnablePointerEvents);
    this.$root.$on('bv::modal::disable-pointer-events', this.onBVModalDisablePointerEvents);
    $('#editOrganicSocialMediaPlanModal .modal-content').removeAttr('tabindex');

    if (!this.userAbilities.editMediaCall || this.deliverableDetail.permissions.viewOnly) {
      $('.add-contact-button, .add-resource-button').removeAttr('title').attr('disabled', 'disabled');
    }
    this.planId = this.deliverableDetail.deliverableId;

    let that = this;
    this.$nextTick(() => {
      that.activeDeliverableTab = 1;
      setTimeout(function () {
        if (that.deliverableDetail.deliverableId !== undefined) {
          // call api to read all alerts after 10 seconds
          that.$store.dispatch(
            'makeAllRelatedAlertRead',
            {
              groupedModelId: that.deliverableDetail.deliverableId
            }
          );
        }
      }, 10000);
    });

  },
  destroyed() {
    this.$root.$off('bv::modal::enable-pointer-events', this.onBVModalEnablePointerEvents);
    this.$root.$off('bv::modal::disable-pointer-events', this.onBVModalDisablePointerEvents);
    this.$root.$emit('postModalClose');

  },

  beforeDestroy() {
    window.removeEventListener('keydown', this.escapeListener);

  },


};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.edit-osmp-deliverable-modal .card-header {
  background-color: var(--wf-secondary);
  padding-left: 0.5rem;
}

section.plan-settings {
  padding: 10px 25px 25px 1px;

  .settings-header {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-left: 0;
  }

  .group-title {
    font-size: 22px;
  }

  .group-title h1 {
    font-size: 2.25rem;
    margin-top: 1rem;
    margin-left: 1rem;
  }

  .settings-content {
    padding-top: 0px;

    .social-media-group-popup {
      padding: 0;

      .row .col-7,
      .row .col-5 {
        flex-basis: 50%;
        max-width: 50%;
      }

      .type-label {
        display: none;
      }

    }
  }
}
</style>
